import { Header, Table } from '@tanstack/react-table'
import { calculateRowSpan } from './calculateRowSpan'
import { findParentHeader } from './findParentHeader'
import { getNestedLevels } from './getNestedLevels'
import { hasOnlyOrphanDescendants } from './hasOnlyOrphanDescendants'
import { isLeaf as isLeafHeader } from './isLeaf'

export const getTableHeaderCellProps = (
    header: Header<unknown, unknown>,
    table: Table<unknown>
) => {
    const parentHeader = findParentHeader(header, table)
    let rowSpan = calculateRowSpan(header, table)
    let isLeaf = isLeafHeader(header)
    let isHidden = false
    let actualHeader = header

    if (parentHeader && calculateRowSpan(parentHeader, table) > 1) {
        isHidden = true
    }

    if (parentHeader && hasOnlyOrphanDescendants(parentHeader)) {
        isHidden = true
    }

    if (hasOnlyOrphanDescendants(header) && !isLeafHeader(header)) {
        actualHeader = findLeaf(header)
        isLeaf = true
        rowSpan = getNestedLevels(header)
    }

    return {
        id: actualHeader.column.id,
        rowSpan,
        colSpan: actualHeader.colSpan,
        canSort: header.column.getCanSort(),

        isHidden,
        isLeaf,
        actualHeader,
    }
}

const findLeaf = (header: Header<unknown, unknown>) => {
    if (header.subHeaders.length) {
        return findLeaf(header.subHeaders[0])
    }

    return header
}
